export class ErrorCodes {
  public static REQUIRED_FIELD = '3.1';
  public static NO_COLLECTION_MISSION = "7.1";
  public static NO_DELIVERY_MISSION = "7.4";
  public static NO_GOODS_ITEMS = '7.2';
  public static GOODS_ITEMS_NOT_DELIVERED = '7.3';
  public static FREIGHTFORWARDER_ACCOUNT_NOT_FOUND = '4.44';
  public static VALIDATION_ERROR_PASSWORD_BANNED = '3.59';
  public static VALIDATION_ERROR_DRIVER_ALREADY_LINKED = '3.64';
  public static VALIDATION_ERROR_VEHICLE_ALREADY_LINKED = '3.65';
}
